const styles = (theme) => ({
  modal: {
    "& .MuiPaper-root" :{
      maxHeight:'90%',
      width:'90%'
      }
    },
    paper: {
      marginTop: theme.spacing(9),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
      marginTop:'25px'
    },
    designerIcon:{
        marginBottom:'25px'
    },
    submit2: {
      marginTop:'20px'
  },
});

export default styles